  <td class="text-center">
      @if (cliente?.ultimoEstadoCliente?.estadoCliente == EstadoCliente.Habilitado) {
        <div class="fondo">
          <small class="text-success fondo text-bold">Habilitado</small>
        </div>
      } @else if (cliente?.ultimoEstadoCliente?.estadoCliente == EstadoCliente.Bloqueado) {
        <div class="fondo">
          <small class="text-danger fondo text-bold">Bloqueado</small>
        </div>
      }
      @if (cliente?.estadoCrediticio?.toLowerCase() == "vencido") {
        <div class="fondo mt-1">
          <small class="text-danger fondo text-bold">Vencido</small>
        </div>
      } @else if (cliente?.estadoCrediticio?.toLowerCase() == "excedido") {
        <div class="fondo mt-1">
          <small class="text-danger fondo text-bold">Excedido</small>
        </div>
      } @else if (cliente?.estadoCrediticio?.toLowerCase() == "excedido y vencido") {
        <div class="fondo mt-1">
          <small class="text-danger fondo text-bold">Excedido y vencido</small>
        </div>
      }
  </td>

  <td class="text-center">
    <button [disabled]="bloquear || !authService.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.EJECUTIVOCUENTA)" id="btnSolicitar"
            class="btn btn-success btn-sm w-size" (click)="solicitar(cliente)">
      <span>Solicitar</span>
    </button>
  </td>

  <td class="text-center">
    <button [disabled]="bloquear || !authService.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.EJECUTIVOCUENTA)" id="btnCrear"
            class="btn btn-success btn-sm w-size" (click)="agregarNotificacion(i, cliente)">
      <span>Crear</span>
    </button>
  </td>

  <td class="text-center">
    <button [disabled]="bloquear" id="btnModificar" *ngIf="authService.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV, TipoUsuario.APROBADORBYR)"
            class="btn btn-success btn-sm" [ngClass]="{'w-size':!cargandoNotificacion[i]}" (click)="modificarConfiguracion(cliente)">
      <span *ngIf="!cargandoConfiguracion[i]">Modificar</span>
      <div *ngIf="cargandoConfiguracion[i]" class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Cargando...</span>
      </div>
    </button>
  </td>

  <td class="text-center">
    <button [disabled]="bloquear" id="btnActualizar" (click)="actualizarSaldo(cliente, i)"
            ngbTooltip="Actualizar saldos" class="btn-sm btn btn-outline-primary text-nowrap">
      <i *ngIf="!actualiza || seleccionado != i" class="fa fa-refresh small"></i>
      <div *ngIf="actualiza && seleccionado == i" class="d-flex align-items-center">
        <div class="spinner-border text-dark spinner-border-sm" role="status"></div>
      </div>
    </button>
  </td>
